import React, { useState, useEffect } from 'react';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { KTSVG } from '../../_metronic/helpers';
import {Table, Form } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { Link, useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';

const ALL_WAREHOUSE_OPTION = { label: 'All Warehouse', value: '' };

const FinishedGoodsStockDetails: React.FC = () => {

    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const idProducts: number = Number(query.get('id_products'));
    const idProjects: string = query.get('id_projects') || '';
    const idWarehouses: string = query.get('id_warehouses') || '';
    const [product, setProduct] = useState<any>(null);
    const [warehouseName, setWarehouseName] = useState('');
    const [stockIn, setStockIn] = useState<any[]>([]);
    const [stockOut, setStockOut] = useState<any[]>([]);
    const [stockTransactions, setStockTransactions] = useState<any[]>([]);
    const [typeSearch, setTypeSearch] = useState('');
    const [productOptions, setProductOptions] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any>(null);
    const [warehouseOptions, setWarehouseOptions] = useState<any[]>([ALL_WAREHOUSE_OPTION]);

    const [formData, setFormData] = useState({
        id_projects: idProjects ? Number(idProjects) : 0,
        id_products: idProducts,
        from_date: '',
        to_date: '',
    });

    const getProducts = async (projectId: string | number) => {
        if (!projectId) {
            setProductOptions([]);
            setSelectedProduct(null);
            return;
        }

        try {
            const url = `${process.env.REACT_APP_API_URL}product-stock-details/products?id_projects=${projectId}`;

            const response = await fetch(url, getRequestOptions());
            const data = await response.json();

            if (data.success && Array.isArray(data.data)) {
                const currentId = Number(new URLSearchParams(location.search).get('id_products'));
                const options = data.data.map((item: any) => ({
                    label: `${item.product_name}${item.packing ? ` (${item.packing}${item.item_unit_name ? ` ${item.item_unit_name}` : ''})` : ''}${item.status ? ` - ${item.status}` : ''}`,
                    value: item.id_products,
                }));
                setProductOptions(options);
                setSelectedProduct(options.find((option: any) => option.value === currentId) || null);
            } else {
                setProductOptions([]);
                setSelectedProduct(null);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setProductOptions([]);
            setSelectedProduct(null);
        }
    };

    const getStockDetails = async () => {
        try {
            const currentQuery = new URLSearchParams(location.search);

            const queryParams = new URLSearchParams({
                id_projects: currentQuery.get('id_projects') || String(formData.id_projects || ''),
                id_products: currentQuery.get('id_products') || String(formData.id_products || ''),
                from_date: formData.from_date,
                to_date: formData.to_date,
            });
            const warehouseId = currentQuery.get('id_warehouses') || '';
            if (warehouseId) {
                queryParams.set('id_warehouses', warehouseId);
            }

            const url = process.env.REACT_APP_API_URL + 'product-stock-details?' + queryParams.toString();

            const response = await fetch(url, getRequestOptions());
            const data = await response.json();
            setProduct(data.data.product);
            setWarehouseName(data.data.warehouseName || '');
            setStockIn(data.data.stockIn);
            setStockOut(data.data.stockOut);
            setStockTransactions(data.data.stockTransactions || []);
            setTypeSearch('');

            const projectId = currentQuery.get('id_projects') || data.data.product?.idProjects || '';
            if (projectId) {
                getProducts(projectId);
            } else {
                setProductOptions([]);
                setSelectedProduct(null);
            }
           
        } catch (error) {
            console.error('catch the hoop', error);
        }
    };
    
    const numberFormat = (value: number) => {
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const getTransactionDetailPath = (row: any): string | null => {
        if (row.id_productions) {
            return `/manufacturing-details/${row.id_productions}`;
        }
        if (row.id_inv_opening_stocks) {
            return `/inventory-opening-details/${row.id_inv_opening_stocks}`;
        }
        if (row.id_inv_warehouse_transfers) {
            return `/warehouse-transfer-details/${row.id_inv_warehouse_transfers}`;
        }
        if (row.id_sales_orders) {
            return `/sales-order/${row.id_sales_orders}`;
        }
        if (row.id_shipments) {
            return `/shipments?shipmentId=${row.id_shipments}`;
        }
        return null;
    };

    const renderDetailLink = (row: any, text: string) => {
        const detailPath = getTransactionDetailPath(row);
        if (!detailPath || !text || text === '-') {
            return text || '-';
        }
        return (
            <Link to={detailPath} target="_blank" rel="noopener noreferrer">
                {text}
            </Link>
        );
    };
   
    useEffect(() => {
        const currentQuery = new URLSearchParams(location.search);
        const nextIdProducts = Number(currentQuery.get('id_products'));
        const nextIdProjects = currentQuery.get('id_projects') ? Number(currentQuery.get('id_projects')) : 0;

        setFormData((prev) => ({
            ...prev,
            id_products: nextIdProducts,
            id_projects: nextIdProjects,
        }));
        setTypeSearch('');
        getStockDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleProductChange = (selected: any) => {
        if (!selected?.value) {
            return;
        }

        const nextQuery = new URLSearchParams(location.search);
        nextQuery.set('id_products', String(selected.value));
        const projectId = idProjects || product?.idProjects || '';
        if (projectId) {
            nextQuery.set('id_projects', String(projectId));
        }
        if (idWarehouses) {
            nextQuery.set('id_warehouses', idWarehouses);
        }
        history.push(`/finished-goods-stock-details?${nextQuery.toString()}`);
    };

    const warehouseProjectId = String(idProjects || product?.idProjects || '');

    const getWarehouses = async (projectId: string) => {
        if (!projectId) {
            setWarehouseOptions([ALL_WAREHOUSE_OPTION]);
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}warehouse/${projectId}/list`, getRequestOptions());
            const data = await response.json();
            const options = data.success && Array.isArray(data.data)
                ? data.data.map((row: any) => ({ label: row.name, value: String(row.id_warehouses) }))
                : [];
            setWarehouseOptions([ALL_WAREHOUSE_OPTION, ...options]);
        } catch (error) {
            console.error('Error fetching warehouses:', error);
            setWarehouseOptions([ALL_WAREHOUSE_OPTION]);
        }
    };

    useEffect(() => {
        getWarehouses(warehouseProjectId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [warehouseProjectId]);

    const selectedWarehouse = warehouseOptions.find((option) => option.value === idWarehouses)
        || (idWarehouses ? { label: warehouseName || 'Selected Warehouse', value: idWarehouses } : ALL_WAREHOUSE_OPTION);

    const handleWarehouseChange = (selected: any) => {
        const nextQuery = new URLSearchParams(location.search);
        if (selected?.value) {
            nextQuery.set('id_warehouses', String(selected.value));
        } else {
            nextQuery.delete('id_warehouses');
        }
        history.push(`/finished-goods-stock-details?${nextQuery.toString()}`);
    };

    const handleViewReport = () => {
        getStockDetails()
    }

    const getExcelDownloadUrl = () => {
        const currentQuery = new URLSearchParams(location.search);
        const params = new URLSearchParams({
            id_projects: currentQuery.get('id_projects') || String(formData.id_projects || ''),
            id_products: currentQuery.get('id_products') || String(formData.id_products || ''),
            from_date: formData.from_date,
            to_date: formData.to_date,
        });
        const warehouseId = currentQuery.get('id_warehouses') || '';
        if (warehouseId) {
            params.set('id_warehouses', warehouseId);
        }
        return `${process.env.REACT_APP_BACKEND}finished_goods_stock_details_download?${params.toString()}`;
    };

    const displayTransactions = stockTransactions.length
        ? stockTransactions
        : (() => {
            const fallbackTransactions = [
                ...stockIn.map((row) => ({
                    ...row,
                    in_qty: Number(row.quantity || 0),
                    out_qty: 0,
                    movement_order: 1,
                })),
                ...stockOut.map((row) => ({
                    ...row,
                    in_qty: 0,
                    out_qty: Number(row.quantity || 0),
                    movement_order: 2,
                })),
            ].sort((a, b) => {
                if (a.date === b.date) return a.movement_order - b.movement_order;
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });

            let runningBalance = 0;
            return fallbackTransactions.map((row) => {
                runningBalance += Number(row.in_qty || 0) - Number(row.out_qty || 0);
                return {
                    ...row,
                    balance_qty: runningBalance,
                };
            });
        })();

    const normalizedTypeSearch = typeSearch.trim().toLowerCase();
    const filteredByType = normalizedTypeSearch
        ? displayTransactions.filter((row) => (row.type || '').toLowerCase().includes(normalizedTypeSearch))
        : displayTransactions;

    const tableTransactions = normalizedTypeSearch
        ? (() => {
            let runningBalance = 0;
            return filteredByType.map((row) => {
                runningBalance += Number(row.in_qty || 0) - Number(row.out_qty || 0);
                return { ...row, balance_qty: runningBalance };
            });
        })()
        : filteredByType;

    const fullStockIn = displayTransactions.reduce((total, row) => total + Number(row.in_qty || 0), 0);
    const fullStockOut = displayTransactions.reduce((total, row) => total + Number(row.out_qty || 0), 0);
    const currentStock = fullStockIn - fullStockOut;

    const columnInSum = tableTransactions.reduce((total, row) => total + Number(row.in_qty || 0), 0);
    const columnOutSum = tableTransactions.reduce((total, row) => total + Number(row.out_qty || 0), 0);
    const filteredCurrentStock = columnInSum - columnOutSum;

    // Warehouse column only when viewing all warehouses
    const showWarehouseColumn = !idWarehouses;
    const extraCols = showWarehouseColumn ? 1 : 0;

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            Finished Goods Stock (In/Out) Details for {product?.productName}
                        </span>
                    </div>
                    <div className="card-toolbar">
                        <div className='d-flex justify-content-end gap-2 align-items-end flex-wrap'>
                            
                            <a
                                className="btn btn-sm btn-primary"
                                href={getExcelDownloadUrl()}
                                title="Download Excel report"
                            >
                                <i className='fas fa-download'></i> Excel Download
                            </a>
                            <Link className="btn btn-info btn-sm" to={`/stock-status`}>
                                <KTSVG
                                    path='/media/svg/icons/Media/Back.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Back to Inventory Stock Status List
                            </Link>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className="row">
                        <div className="col mb-2">
                            <p className='mb-0'><strong>Product Name:</strong> {product?.productName}</p>
                            <p className='mb-0'><strong>Category:</strong> {product?.categoryName}</p>
                            <p className='mb-0'><strong>Packing:</strong> {product?.packing}</p>
                            <p className='mb-0'><strong>Size:</strong> {product?.size}</p>
                            <p className='mb-0'><strong>Unit:</strong> {product?.item?.unit?.unitName}</p>
                            <p className='mb-0'><strong>Stock:</strong> {numberFormat(currentStock)}</p>
                            <p className='mb-0'><strong>Warehouse:</strong> {idWarehouses ? (warehouseName || '-') : 'All Warehouse'}</p>
                            <p className='mb-0'><strong>Status:</strong> {product?.status || '-'}</p>
                        </div>
                        <div className='col' style={{ minWidth: '260px' }}>
                            <Form.Label className='mb-1'>Change Product</Form.Label>
                            <Select
                                value={selectedProduct}
                                onChange={handleProductChange}
                                options={productOptions}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                placeholder="Select Product"
                            />
                            <Form.Label className='mb-1 mt-3'>Warehouse</Form.Label>
                            <Select
                                value={selectedWarehouse}
                                onChange={handleWarehouseChange}
                                options={warehouseOptions}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                placeholder="Select Warehouse"
                                isDisabled={!warehouseProjectId}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-2'>
                            <Form.Group className="mb-3" controlId="from_date">
                                <Form.Label>From Date<span className='required'></span></Form.Label>
                                <Form.Control type="date" placeholder="From Date" name='from_date' onChange={handleChange}  className='form-control-sm'/>
                            </Form.Group>
                        </div>
                        <div className='col-md-2'>
                            <Form.Group className="mb-3" controlId="to_date">
                                <Form.Label>To Date<span className='required'></span></Form.Label>
                                <Form.Control type="date" placeholder="To Date" name='to_date' onChange={handleChange} className='form-control-sm'/>
                            </Form.Group>
                        </div>
                        <div className='col-md-2'>
                            <div className="form-control-sm ps-0 mt-7">
                                <button className='btn btn-sm btn-primary w-100 p-2' onClick={handleViewReport}>
                                    <span>GO</span>
                                </button>
                            </div>                                
                        </div>
                        <div className='col-md-2'>
                            <div className="form-control-sm ps-0 mt-7">
                                <a
                                    className='btn btn-sm btn-success w-100 p-2'
                                    href={getExcelDownloadUrl()}
                                    title="Download Excel with current filters"
                                >
                                    <i className='fas fa-file-excel'></i> Excel
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col">
                            {normalizedTypeSearch && (
                                <p className='text-muted small mb-2'>
                                    Showing <strong>{tableTransactions.length}</strong> of <strong>{displayTransactions.length}</strong> records
                                    {typeSearch.trim() && <> matching &quot;<strong>{typeSearch.trim()}</strong>&quot;</>}
                                </p>
                            )}
                            <Table striped bordered hover size="sm">
                                <thead className='table-light'>
                                    <tr>
                                        <th>Date</th>
                                        {showWarehouseColumn && <th>Warehouse</th>}
                                        <th>Type</th>
                                        <th>Manufacturing Ref. No/Shipment Ref. No </th>
                                        <th className='text-center'>Rate </th>
                                        <th className='text-end'>In Qty</th>
                                        <th className='text-end'>Out Qty</th>
                                        <th className='text-end'>Balance Qty</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={1 + extraCols}></th>
                                        <th className='p-2' style={{ minWidth: '160px' }}>
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Search type..."
                                                value={typeSearch}
                                                onChange={(e) => setTypeSearch(e.target.value)}
                                                className='form-control-sm'
                                            />
                                        </th>
                                        <th colSpan={5}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableTransactions.length === 0 ? (
                                        <tr>
                                            <td colSpan={7 + extraCols} className='text-center text-muted py-4'>
                                                No records found for this type search.
                                            </td>
                                        </tr>
                                    ) : (
                                        tableTransactions.map((row, index) => (
                                            <tr key={`txn-${index}`}>
                                                <td>{row.date}</td>
                                                {showWarehouseColumn && <td>{row.warehouseName || '-'}</td>}
                                                <td>{renderDetailLink(row, row.type || '-')}</td>
                                                <td>{renderDetailLink(row, row.referenceNo || '-')}</td>
                                                <td className='text-end'>{row.rate}</td>
                                                <td className='text-end'>{Number(row.in_qty) ? numberFormat(Number(row.in_qty)) : '-'}</td>
                                                <td className='text-end'>{Number(row.out_qty) ? numberFormat(Number(row.out_qty)) : '-'}</td>
                                                <td className='text-end'>{numberFormat(Number(row.balance_qty || 0))}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className='table-light'>
                                        <th colSpan={4 + extraCols} className='text-end'><strong>Total</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnInSum)}</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnOutSum)}</strong></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={6 + extraCols} className='text-end'><strong>Total Stock In</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnInSum)}</strong></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={6 + extraCols} className='text-end'><strong>Total Stock Out</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnOutSum)}</strong></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={6 + extraCols} className='text-end'><strong>Current Stock</strong></th>
                                        <th className='text-end'><strong>{numberFormat(normalizedTypeSearch ? filteredCurrentStock : currentStock)}</strong></th>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                    </div>
                    

                    <div className='row'>
                        <div className='col text-center'>

                            <Link className="btn btn-info btn-sm" to={`/stock-status`}>
                                <KTSVG
                                    path='/media/svg/icons/Media/Back.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Back to Inventory Stock Status List
                            </Link>

                        </div>
                    </div>
                </div>
                
            </div>
            
        </>
    )
}

export default FinishedGoodsStockDetails
